import Grid from '@mui/material/Grid'
import { CustomFieldList } from '@user/components/Leads/AddLeadForm/FormSections/OtherInformation/CustomFieldList'
import * as React from 'react'
import { useMemo } from 'react'
import { useSelectCustomFieldData } from '@user/store/customFields'
import { TextFieldProps } from '@mui/material/TextField'
import { FormSection } from '@sales-center/components'

type Props = {
  customFieldsVisible: boolean
  hideOptional: boolean
  show: boolean
  spacing?: number
  textFieldProps?: TextFieldProps
  maxWidth?: string
  avoidValidateOnBlur?: boolean
}

export function LeadCustomFields(props: Props) {
  const {
    hideOptional,
    customFieldsVisible,
    show,
    spacing = 2,
    textFieldProps,
    maxWidth,
    avoidValidateOnBlur = false,
  } = props
  const data = useSelectCustomFieldData()

  const showCustomFields = useMemo(
    () =>
      customFieldsVisible &&
      (!hideOptional ||
        !!data.customSettings.find((setting) => setting.required)),
    [customFieldsVisible, data.customSettings, hideOptional],
  )

  return showCustomFields ? (
    <FormSection
      label="Custom Fields"
      maxWidth={maxWidth || '660px'}
      paddingBottom={0}
    >
      <Grid container item xs={12} spacing={spacing}>
        <CustomFieldList
          {...data}
          hideOptional={!show || hideOptional}
          textFieldProps={textFieldProps}
          margin="none"
          avoidValidateOnBlur={avoidValidateOnBlur}
        />
      </Grid>
    </FormSection>
  ) : null
}
